import config from 'react-global-configuration';

export const setFlag = (flag_id, entity_type, entity_id, params = {}) => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          fetch(`${PATH}/entity/flagging/${flag_id}/${entity_type}/${entity_id}?_format=json`, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify(params),
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) {
                resolve(response);
              } else {
                throw new Error();
              }
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
};

export const removeFlag = (flag_id, entity_type, entity_id) => {
  return (dispatch, getState) => {
    const API_URL = config.get('API_URL');
    const language = getState().getIn(['ui', 'language']);
    const MULTILINGUAL = config.get('MULTILINGUAL', true);
    const PATH = MULTILINGUAL ? `${API_URL}/${language}` : API_URL;

    return new Promise((resolve, reject) => {
      fetch(`${PATH}/rest/session/token?_format=json`, {
        credentials: 'include',
      })
        .then((response) => response.text())
        .then((response) => {
          const csrfToken = response;

          fetch(`${PATH}/entity/flagging/${flag_id}/${entity_type}/${entity_id}?_format=json`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': csrfToken,
            },
          })
            .then((response) => {
              if (response.ok) {
                resolve(response);
              } else {
                throw new Error();
              }
            })
            .catch((error) => {
              reject(error);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
};
